import React from 'react'

const UnableCommet = () => {
  return (
    <div style={{
        textAlign :'center' ,
        marginTop : '20px'
    }}>Tính năng bình luận đã bị tắt. <a style={{ color :'blue' , cursor:'pointer' }}>Tìm hiểu thêm</a></div>
  )
}

export default UnableCommet